import {
  Cookie as CookieClient,
  createRealTimeCookie,
} from "@cookie-baker/browser";
import { atom } from "@reatom/framework";
import { reatomCookie } from "@reatom/npm-cookie-baker";

export const pageConstructorAtom = atom(false);

type pageConstructorEnabledModel = {
  isPageConstructor?: string;
};

const cookie = new CookieClient<pageConstructorEnabledModel>();
const realTimeCookie = createRealTimeCookie(cookie);

export const pageConstructorEnabledAtom = reatomCookie(cookie, realTimeCookie);

export const isPageConstructorEnabledAtom = atom((ctx) => {
  const pageConstructorEnabledCookie = ctx.spy(
    pageConstructorEnabledAtom.cookieAtom,
  );
  return !!pageConstructorEnabledCookie.isPageConstructor;
});
